// Slovenské dvojče locale/cs/notFoundPage.js.
export default {
  code: '404',
  eyebrow: 'Stránka nenájdená',
  title: 'Jejda! Túto stránku sme nenašli.',
  perex:
    'Odkaz je asi starý alebo obsahuje preklep. Produkt mohol tiež zmeniť názov. ' +
    'Skúste hľadať podľa názvu náradia, alebo sa rovno prekliknite do hlavných kategórií.',
  placeholder: 'Napíšte, čo hľadáte',
  popularLabel: 'Najhľadanejšie:',
  where: 'Kam ďalej',
  linksTitle: 'Časté odkazy',
  best: 'Najpredávanejšie',

  tiles: {
    garden: { name: 'Záhrada', desc: 'Krovinorezy, kosačky, zavlažovanie a píly.' },
    build: { name: 'Stavba a dom', desc: 'Miešačky, centrály, čerpadlá a kúrenie.' },
    workshop: { name: 'Dielňa', desc: 'Aku náradie, zváranie a ručné náradie.' },
    brands: { name: 'Značky', desc: 'Celý sortiment podľa výrobcu, A–Z.' },
    sale: { name: 'Zľavy', desc: 'Zlacnené stroje a výpredaje skladom.' },
    service: { name: 'Servis náradia', desc: 'Opravy, údržba a náhradné diely.' },
  },

  links: {
    orderStatus: 'Stav objednávky',
    shipping: 'Doprava a platba',
    claim: 'Reklamačný formulár',
    withdrawal: 'Odstúpenie od zmluvy do 14 dní',
    contact: 'Kontakt a predajňa',
  },

  // SK: neověřeno ve fixtures — homepage skupina „Najpredávanejšie"/„Najobľúbenejšie"
  bestHeadingRe: /najpred|najobľ/i,

  advice: {
    eyebrow: 'Poradňa Jipos',
    title: 'Povedzte nám, čo ste hľadali',
    text: 'Zavolajte alebo napíšte. Nájdeme model, poradíme s alternatívou a overíme dostupnosť.',
    textNoPhone: 'Napíšte nám. Nájdeme model, poradíme s alternatívou a overíme dostupnosť.',
    writeQuestion: 'Napísať dotaz',
  },
};
